import angular from 'angular';
import fbTrixCtrl from './fb-trix.controller'

let fbTrix = {
  template: require('./fb-trix.html'),
  require: { ngModel: 'ngModel' },
  bindings: {
    /* 
      Inputs
      hero: '<',    // one-way binding, changing shoudln't update parent scope
                       mutations to objects or arrays should occur in parent
      comment: '@'  // for static strings
      Outputs: & bindings, callbacks for component events
      onDelete: '&'
      onUpdate: '&'
    */
    fbOnPaste: '&',
    fbTrixPreventFile: '@',
    fbTrixInit: '&',
    fbTrixChange: '&',
    fbTrixSelectionChange: '&',
    fbTrixFocus: '&',
    fbTrixBlur: '&',
    fbTrixFileAccept: '&',
    fbTrixAttachmentAdd: '&',
    fbTrixAttachmentRemove: '&'
  },
  controller: fbTrixCtrl
}

export default angular.module('components.fb-trix', [])
  .component('fbTrix', fbTrix)
  .name;



// WEBPACK FOOTER //
// ./project/components/fb-trix/index.js